import { useAuth } from "@/auth/AuthContext";
import { GlobalSearch } from "@/components/GlobalSearch";
import { NotificationCenter } from "@/components/NotificationCenter";
import { RoleAccessBadge } from "@/components/RoleAccessBadge";

type Props = {
  onMenuToggle?: () => void;
};

export function TopBar({ onMenuToggle }: Props) {
  const { user, logout } = useAuth();

  return (
    <header className="topbar">
      <div className="topbar-left">
        <button type="button" className="hamburger-btn btn btn-ghost" aria-label="Open navigation" onClick={onMenuToggle}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden>
            <path d="M4 7h16M4 12h16M4 17h16" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          </svg>
        </button>
        <div style={{ display: "flex", gap: "0.75rem", alignItems: "center", minWidth: 0 }}>
          <strong className="topbar-agency">{user?.agency?.display_name ?? "Andrew Insurance"}</strong>
          <RoleAccessBadge />
        </div>
      </div>
      <div className="topbar-center">
        <GlobalSearch />
      </div>
      <div className="topbar-right">
        <NotificationCenter />
        <span className="topbar-email">{user?.email}</span>
        <button type="button" className="btn btn-ghost" onClick={() => logout()}>
          Sign out
        </button>
      </div>
    </header>
  );
}
